import Layout from "components/Layout";
import React from "react";
import GroupDataTable from "./Components/GroupDataTable";

function Group() {
  return (
    <Layout title="그룹 목록">
      <GroupDataTable />
    </Layout>
  );
}

export default Group;
